import { render, staticRenderFns } from "./SettingsUser.vue?vue&type=template&id=3c4650c2&scoped=true"
import script from "./SettingsUser.vue?vue&type=script&lang=js"
export * from "./SettingsUser.vue?vue&type=script&lang=js"
import style0 from "./SettingsUser.vue?vue&type=style&index=0&id=3c4650c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4650c2",
  null
  
)

export default component.exports